import styled from "styled-components";
import { Table as ANTTable } from "antd";
import { themeProp } from "../theme";
import { getTooltipDefaultAttributes } from "./Tooltip";

const Table = styled(ANTTable).attrs((props) => ({
  showSorterTooltip: {
    ...getTooltipDefaultAttributes(props)
  }
}))`
  .ant-table {
    margin-right: -1px;
  }
  .ant-table-column-sorter {
    &-up,
    &-down {
      color: ${themeProp("palette.gray2")};

      &.active {
        color: ${themeProp("palette.primary")};
      }
    }
  }
  .ant-table-column-sorters {
    padding: 0 16px;
  }

  .ant-table-thead .ant-table-cell {
    font-family: ${themeProp("typography.label.fontFamily")};
    font-size: ${themeProp("typography.small.fontSize")};
    font-weight: ${themeProp("typography.small.fontWeight")};
    line-height: ${themeProp("typography.small.lineHeight")};
    color: ${themeProp("palette.gray4")};
    background: ${themeProp("palette.gray2")};
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .ant-table-tbody .ant-table-cell {
    font-family: ${themeProp("typography.body.fontFamily")};
    font-size: ${themeProp("typography.body.fontSize")};
    font-weight: ${themeProp("typography.body.fontWeight")};
    line-height: ${themeProp("typography.body.lineHeight")};
    color: ${themeProp("palette.text")};

    &.ant-table-column-sort {
      background: ${themeProp("palette.gray1")};
    }
  }

  & .ant-table-tbody > tr.ant-table-row-selected > td,
  & tr.ant-table-row-selected {
    background-color: ${themeProp("palette.gray1")};
  }

  .ant-table-pagination {
    .ant-pagination-item a {
      transform: translateY(1px);
    }

    .ant-pagination-item,
    .ant-pagination-prev,
    .ant-pagination-next {
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${themeProp("palette.primary")};
      border-color: ${themeProp("palette.gray2")};

      a {
        color: inherit;
        line-height: none;
      }

      svg {
        transform: translateY(-1px);
      }

      &-active,
      &:hover {
        border-color: ${themeProp("palette.secondary")};
        color: ${themeProp("palette.secondary")};

        & > a {
          color: inherit;
        }
      }

      &:focus-visible {
        box-shadow: 0 0 0 4px ${themeProp(`palette.focus`)};
        border-color: transparent;
      }
    }
    .ant-pagination-item-link {
      color: ${themeProp("palette.primary")};
      border-color: ${themeProp("palette.gray2")};

      &:hover {
        border-color: ${themeProp("palette.secondary")};
        color: ${themeProp("palette.secondary")};

        & > a {
          color: inherit;
        }
      }
    }
    .ant-pagination-disabled {
      .ant-pagination-item-link {
        color: ${themeProp("palette.gray2")};
        border-color: ${themeProp("palette.gray2")};

        &:hover {
          border-color: ${themeProp("palette.gray2")};
          color: ${themeProp("palette.gray2")};

          & > a {
            color: inherit;
          }
        }
      }
    }
  }
`;

export default Table;
